import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Card, CardBody, Badge, Button, Spinner, Alert } from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const fmtDate = (v) => (v ? new Date(v).toLocaleString("tr-TR") : "—");
const fmtTL = (v) =>
  v || v === 0 ? Number(v).toLocaleString("tr-TR", { minimumFractionDigits: 2 }) + " ₺" : "—";

const platformBadge = (p) => {
  const v = (p || "").toLowerCase();
  if (v.includes("ios") || v.includes("apple")) return <Badge color="dark"><i className="bx bxl-apple" /> iOS</Badge>;
  if (v.includes("android")) return <Badge color="success"><i className="bx bxl-android" /> Android</Badge>;
  return <Badge color="secondary">{p || "—"}</Badge>;
};

const SatinAlmaGecmisi = () => {
  document.title = "Satın Alma Geçmişi | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  const [liste, setListe] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchListe = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const url = `${BASE_URL}/SATIN_ALMA_GECMISI?$orderby=ID desc&$top=1000` +
        `&$expand=KULLANICILAR($select=AD_SOYAD,ISLETME_AD),PAKETLER($select=AD,TIP)`;
      const res = await fetch(url, { headers });
      const result = await res.json();
      setListe(result.value || []);
    } catch {
      setError("Satın alma geçmişi yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchListe(); }, []);

  const toplamCiro = useMemo(
    () => liste.reduce((s, r) => s + (Number(r.TUTAR) || 0), 0),
    [liste]
  );

  const columns = useMemo(() => [
    { header: "#", accessorKey: "ID", enableSorting: true, cell: (c) => <strong>#{c.getValue()}</strong> },
    {
      header: "Kullanıcı", accessorKey: "KULLANICI_ID", enableSorting: true,
      cell: (c) => {
        const u = c.row.original.KULLANICILAR;
        return <span className="fw-medium">{u?.AD_SOYAD || u?.ISLETME_AD || `#${c.getValue()}`}</span>;
      },
    },
    {
      header: "Paket", accessorKey: "PAKETLER_ID", enableSorting: true,
      cell: (c) => {
        const p = c.row.original.PAKETLER;
        return <Badge color="light" className="text-dark">{p?.AD || (c.getValue() ? `#${c.getValue()}` : "—")}</Badge>;
      },
    },
    {
      header: "Tutar", accessorKey: "TUTAR", enableSorting: true,
      cell: (c) => <span className="fw-bold text-success">{fmtTL(c.getValue())}</span>,
    },
    {
      header: "SKU", accessorKey: "SKU", enableSorting: true,
      cell: (c) => <small className="text-muted">{c.getValue() || "—"}</small>,
    },
    {
      header: "Platform", accessorKey: "PLATFORM", enableSorting: true,
      cell: (c) => platformBadge(c.getValue()),
    },
    {
      header: "Tarih", accessorKey: "TARIH", enableSorting: true,
      cell: (c) => <small className="text-muted">{fmtDate(c.getValue())}</small>,
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Finans" breadcrumbItem="Uygulama İçi Satın Almalar" />
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <div>
                      <h4 className="card-title mb-1">Uygulama İçi Satın Almalar</h4>
                      <p className="text-muted small mb-0">
                        iOS / Android paket ve hak satışları. Toplam {liste.length} işlem ·{" "}
                        <span className="text-success fw-bold">{fmtTL(toplamCiro)}</span> ciro.
                      </p>
                    </div>
                    <Button color="primary" size="sm" onClick={fetchListe} disabled={isLoading}>
                      <i className="bx bx-refresh" /> Yenile
                    </Button>
                  </div>
                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={liste}
                      isGlobalFilter={true}
                      isPagination={true}
                      customPageSize={15}
                      SearchPlaceholder="Ara..."
                      tableClass="align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination pagination-rounded justify-content-end mb-2"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SatinAlmaGecmisi;
